export class LigneFinancementProduit {
         id: number | undefined;
         code: string;
         montant: number;
         libelle: string;
    ligneFinancementSecteurId:number;
       }